import React, { createContext, useContext, useState } from 'react';

const AnalysesContext = createContext();

export const useAnalyses = () => {
  const context = useContext(AnalysesContext);
  if (!context) {
    throw new Error('useAnalyses must be used within AnalysesProvider');
  }
  return context;
};

export const AnalysesProvider = ({ children }) => {
  // États pour la période couverte (page Analyses)
  const [selectedPeriod, setSelectedPeriod] = useState('mois'); // 'jour', 'semaine', 'mois', 'periode'
  const [dateRange, setDateRange] = useState([null, null]);
  const [selectedVille, setSelectedVille] = useState('tous');
  const [selectedRegion, setSelectedRegion] = useState('tous');

  // État pour filtrer les sections d'analyses à afficher (multi-sélection)
  const [selectedAnalyses, setSelectedAnalyses] = useState(['tous']);

  const toggleSelectedAnalysis = (analysisKey) => {
    if (analysisKey === 'tous') {
      setSelectedAnalyses(['tous']);
      return;
    }

    setSelectedAnalyses((prev) => {
      const current = Array.isArray(prev) ? prev : [prev];
      const withoutTous = current.filter((item) => item !== 'tous');

      if (withoutTous.includes(analysisKey)) {
        const next = withoutTous.filter((item) => item !== analysisKey);
        return next.length > 0 ? next : ['tous'];
      }

      return [...withoutTous, analysisKey];
    });
  };

  return (
    <AnalysesContext.Provider value={{
      selectedPeriod,
      setSelectedPeriod,
      dateRange,
      setDateRange,
      selectedVille,
      setSelectedVille,
      selectedRegion,
      setSelectedRegion,
      selectedAnalyses,
      setSelectedAnalyses,
      toggleSelectedAnalysis
    }}>
      {children}
    </AnalysesContext.Provider>
  );
};


